/*Этот файл должен загружаться первым*/

import { PHP } from "./PHP";

window.JED = {};//Префикс для наших переменных
//JED.act = {};//для запуска функций по имени в переменных
var html = document.querySelector('html');
var body = document.body;
//page = new Page(body);
JED.pgId = body.getAttribute('data-id');//получаем id из PHP.
JED.eTargetPgId = JED.pgId//ID страницы (выбранной карточки)  
if (!JED.pgId) console.log('Не найден аттрибут id шаблона <body data-id...>');
JED.tmpl = body.getAttribute('data-tmpl');//получаем имя шаблона из PHP. 
JED.pgUsr = body.getAttribute('data-usr');//ID пользователя текущей страницы.
JED.pgPrmt = body.getAttribute('data-prmt');//Права пользователя текущей страницы. 
JED.parent = body.getAttribute('data-pid');
JED.pgDraft = document.body.getAttribute("data-draft");
JED.childs = document.body.getAttribute("data-childs");
JED.selection = null;
JED.isMobile = ((document.ontouchstart === null) ? (1) : (0));
JED.W = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
JED.H = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

//Кука идентификации хранится простой строкой с разделителем | не в JSON
if (t = document.cookie.match(new RegExp('(^| )id=([^;]+)'))) {
    t = t[2];
    var arr = decodeURIComponent(t).split('|');//
    JED.usrId = arr[0];//Аутенфицироанный пользователь
    JED.phone = arr[1];//Аутенфицироанный пользователь
    JED.usrPermit = arr[3];//Права пользователя
    //console.log('document.cookie.id = ',usrId);
    //console.log('JED.usrId = ',JED.usrId,' / ',JED.usrPermit);
    //JED.usrPermit = 255;
    //JED.usrPermit = 0;
} else {
    JED.usrId = 0;
    JED.usrPermit = 0;
}

JED.tune = getCookie('tune');
if (!JED.tune) {
    JED.tune = { edit: 0, scale: 0, thema: 0 };
    setCookie("tune", JED.tune);
}

//console.log('document.cookie=',document.cookie);
//if(!(JED.basket = getCookie('basket'))) JED.basket = {};

if (JED.tune.scale == 1) html.classList.add('bigFont');

//if (JED.tune.thema) body.classList.add('dark');
//Установим referrer
//JED.refer = getCookie('refer');
//if (JED.tune.edit) {
//Отключим сохранение режима редактирования при переходе на др страницу
//JED.tune.edit = 0;
//setCookie("tune", JED.tune);//
//JED.refer = '/?t='+JED.tmpl+'&id='+JED.pgId;
//}
//console.log('JED.refer = ',JED.refer);

if (JED.isMobile && PHP.debug > 0) {
    //Создаём контейнер div.console
    const consoleBox = document.createElement("div");
    consoleBox.className = 'console';
    body.append(consoleBox);
    console.log = function () {
        for (let i = 0; i < arguments.length; i++) {
            if (typeof arguments[i] == 'object') {
                consoleBox.innerHTML += arguments[i] + "\n";
            } else {
                consoleBox.innerHTML += arguments[i] + "\n";
            }
        }
    }
}